export default __webpack_public_path__ + "static/media/verified15x15.85d8a1a3.svg";